import { render, staticRenderFns } from "./exportped.vue?vue&type=template&id=29143c70&scoped=true&"
import script from "./exportped.vue?vue&type=script&lang=js&"
export * from "./exportped.vue?vue&type=script&lang=js&"
import style0 from "./exportped.vue?vue&type=style&index=0&id=29143c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29143c70",
  null
  
)

export default component.exports